import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboAcompanhamentoIdoso = [...NIVEL_SUPERIOR, ...NIVEL_TECNICO]
